var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.sluzba
      ? _c(
          "div",
          [
            _vm.sluzba.id == 2 ? _c("sluzba-automatizace-detail") : _vm._e(),
            _vm._v(" "),
            _vm.sluzba.id == 4 ? _c("sluzba-eshopy-detail") : _vm._e(),
            _vm._v(" "),
            _vm.sluzba.id == 10 ? _c("sluzba-print-detail") : _vm._e(),
            _vm._v(" "),
            _vm.sluzba.id == 12 ? _c("sluzba-weby-detail") : _vm._e(),
            _vm._v(" "),
            _vm.sluzbaSide ? _c("CTA") : _vm._e(),
            _vm._v(" "),
            !_vm.sluzbaSide ? _c("Footer") : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }